import React from 'react';

const Icon = ({ 
  children, 
  size = 24,
  viewBoxSize = 24,
  color = 'currentColor', 
  className = '',
  ...props 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={["0", "0", viewBoxSize, viewBoxSize].join(" ")}
      fill="none"
      className={className}
      {...props}
    >
      {children}
    </svg>
  );
};

export default Icon;
